export enum Consciousness {
  Stupor = 'stupor',
  Comatose = 'comatose',
}

export enum NutritionalStatus {
  Obese = 'obese',
}

export enum RespiratoryType {
  Restricted = 'restricted',
  Obstructed = 'obstructed',
  Diverse = 'diverse',
  Percussion = 'percussion',
}

export enum HeatType {
  Normal = 'normal',
  ElectiveCesarean = 'elective_cesarean',
  Cesarean = 'cesarean',
}

export enum AppointmentDuration {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Year = 'year',
}

export enum ActivityStatus {
  Created = 'created',
  InProgress = 'in_progress',
  Cancelled = 'cancelled',
  Processed = 'processed',
}

export enum PaymentMethod {
  CreditCard = 'credit_card',
  DebitCard = 'debit_card',
  Cash = 'cash',
  Other = 'other',
}

export enum PetSex {
  Male = 'M',
  Female = 'F',
}

export enum PetStatus {
  Active = 'active',
  Defeated = 'defeated',
  Suspended = 'suspended',
}
